import React from 'react';

import { ChevronDown } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';

import { SidebarSectionProps } from './types';

function SidebarSection(props: SidebarSectionProps) {
  const { section, open } = props;

  return (
    <Stack alignItems="center" className="group mb-16 ps-16" justifyContent="between">
      <Typography color="text-text-primary" variant="heading-xxs">
        {section.label}
      </Typography>
      <ChevronDown
        className={cn(
          'mx-4 h-20 w-20 flex-none transform text-icon-placeholder transition-transform group-hover:text-icon-secondary',
          open ? 'rotate-0' : '-rotate-90',
        )}
      />
    </Stack>
  );
}

export default SidebarSection;
